import React, { useCallback, useEffect, useState } from 'react'
import './Themes.css'

/**
 * Semantic token suffixes. Each theme must define --{theme}-{suffix} in index.css.
 * Components use var(--{suffix}) only — never --nightsky-* hard-locks.
 *
 * Rule: NightSky palette values are the visual reference. New tokens must equal
 * the previous hardcode (including #RRGGBBAA alpha) on NightSky.
 */
export const THEME_TOKEN_SUFFIXES = [
  // Shell / panes (original engine)
  'dialog-1-bg-color',
  'canvas-background-color',
  'canvas-color',
  'pane-1-background-color',
  'pane-2-background-color',
  'pane-3-background-color',
  'pane-4-background-color',
  'pane-2-color',
  'pane-2-title-background-color',
  'pane-2-title-color',
  'link-color',
  'header-link-color',
  'link-hover-color',
  'link-hover-background-color',
  'link-active-color',
  'link-active-hover-color',
  'link-active-border-color',
  'link-active-background-color',
  'button-hover-border-color',
  'button-hover-active-border-color',
  'config-crumbs-background-color',
  'path-crumbs-background-color',
  'pane-shadow-color',
  'sdk-box-color',
  'sdk-box-background-color',
  'beta-text-color',
  'beta-background-color',
  // Toggle text (was nightsky-only lock-in)
  'tgl-txt-dorm',
  'tgl-txt-dorm-hover',
  'tgl-txt-dorm-bord',
  'tgl-txt-dorm-bord-hover',
  'tgl-txt-act',
  'tgl-txt-act-hover',
  'tgl-txt-act-bord',
  'tgl-txt-act-bord-hover',
  'toggle-color',
  'toggle-border-color',
  'toggle-border-active',
  'toggle-hover',
  'toggle-color-active',
  'toggle-background',
  'toggle-hover-active',
  // Invite / team canary (exact prior hardcodes on NightSky)
  'invite-header-bg',
  'invite-header-border',
  'invite-form-border',
  // Forms (exact prior hardcodes)
  'form-title-bg',
  'form-title-fg',
  'form-body-bg',
  'form-body-fg',
  'taskcard-border',
  'taskcard-blue',
  'taskcard-orange',
  'taskcard-green',
  'taskcard-lime',
  'taskcard-purple',
  'taskcard-dark',
  'tasktag-danger',
  'grouper-wash',
  'text-muted-bbb',
  'text-near-white',
  'white-90',
  'white-solid',
  'white-short',
  'black-30',
  'tbl-header',
  'header-brand-soft',
  'header-cream',
  'danger-short',
  'cube-bisque',
  'cube-brown-a',
  'cube-cornflower',
  'cube-cadet',
  'cube-green-a',
  'cube-salmon',

  'item-key-color',
  'item-key-custom-color',
  'item-key-hover-color',
  'item-hover-bg',
  'item-edit-bg',
  'item-locked-fg',
  'item-locked-stripe',
  'item-border-hover',
  'item-val-color',
  'item-shadow',
  'prog-key-hover-fg',
  'insight-new-bg',
  'label-cell-bg',
  'label-cell-fg',
  'label-cell-placeholder-fg',
  'label-cell-placeholder-bg',
  'edit-cell-fg',
  'edit-cell-bg',
  'config-row-sep',
  'config-sep',
  'config-row-hover-bg',
  'config-header-muted',
  'config-new-row-bg',
  'config-warn',
  'subfolder-border',
  'subfolder-bg-deep',
  'subfolder-ok-bg',
  'subfolder-err-bg',
  'folder-header-bg',
  'folder-item-bg',
  'folder-item-fg',
  'folder-item-key-fg',
  'subfolder-title-bg',
  'folder-accent',
  'chrome-label-color',
  'team-panel-bg',
  'team-panel-border',
  'shadow-inset',
  'gold-line-soft',
  'gold-line-mid',
  'prio-bar-tint',
  'task-card-bg',
  'task-card-border',
  'task-accent-peach',
  'error-tint',
  'lock-stripe-soft',
  'action-warm-bg',
  'action-warm-bg-strong',
  'action-warm-fg',
  'delete-tint',
  'color-tag-border',
  'tags-bar-bg',
  'prio-high-bg',
  'prio-med-bg',
  'prio-low-bg',
  'color-tag-border-soft',
  'task-stage-1-bg',
  'task-stage-2-bg',
  'task-stage-3-bg',
  'gold-line-faint',
  'gold-line-fainter',
  'gold-line-soft2',
  'task-done-bg',
  'tab-dorm-bg',
  'tab-act-bg',
  'footer-alert-bg',
  'profile-panel-bg',
  'planner-tag-bg',
  'error-msg-bg',
  'error-panel-bg',
  'error-panel-fg',
  'error-warn-bg',
  'error-warn-fg',
  'areyousure-bg',
  'areyousure-danger',
  'areyousure-danger-solid',
  'delete-yes-bg',
  'border-muted',
  'border-dark',
  'text-soft-gray',
  'crumb-bg',
  'search-accent',
  'search-accent-bright',
  'panel-deep',
  'ctrl-warm-fg',
  'ctrl-danger-deep',
  'glide-opaque-black',
  'selector-card-idle',
  'selector-card-title',
  'toggle-view-accent',
  'color-tag-link',
  'taska-muted',
  'taska-gold-wash',
  'poping-title-fg',
  'tiny-tag-bg',
  'tiny-tag-fg',
  'cell-ctrl-danger',
  'infocube-wash',
  'infocube-brown-text',
  'progress-timeout-a',
  'progress-timeout-b',
  'footer-text-light',
  'login-muted',
  'login-link',
  'taskcard-bg',
  'todo-warm-fg',
  'join-muted',
  'profile-border',
  'signup-option-bg',
  'areyousure-title',
  'folder-cmd-bg',
  'folder-card-bg',
  'items-muted',
  'history-crumbs-bg',
  'setup-card-bg',
  'setup-add-fg',
  'setup-add-bg',
  'setup-card-warn',
  'setup-card-muted',
  'selector-gold',
  'selector-overlay',
  'selector-panel',
  'wizard-folder-border',

  'areyousure-ok',
  'areyousure-ok-fg',
  'cube-navy',
  'cube-dim',
  'cube-purple',
  'cube-olive',
  'cube-cyan',
  'cube-brown',
  'error-msg-title',
  'error-msg-dark',
  'config-error-fg',
  'config-error-info-bg',



  'auto-rgba-128-128-128-0-171',
  'auto-rgb-18-97-15',
  'auto-4d240833',
  'auto-rgb-18-167-5',
  'auto-rgb-6-90-6',
  'auto-103163',
  'auto-348',
  'auto-932',
  'auto-rgba-32-23-3-0-52',
  'auto-716139',
  'auto-212',
  'auto-234',
  'auto-9bb9d4',
  'auto-666',
  'auto-rgba-218-165-32-0-308',
  'auto-040424',
  'auto-b09a43',
  'auto-b1aa98',
  'auto-b77729',
  'auto-0f023e',
  'auto-075454b0',
  'auto-c0c0c069',
  'auto-9d96fa22',
  'auto-22c55e80',
  'auto-000000',
  'auto-00d000',
  'auto-1d28074f',
  'auto-c0c0c086',
  'auto-6f868d23',
  'auto-rgba-218-165-32-0-274',
  'auto-c0c0c0',
  'auto-rgba-192-192-192-0-473',
  'auto-c0c0c02e',
  'auto-c0c0c070',
  'auto-rgb-211-206-132',
  'auto-0e1d2f',
  'auto-79ffff',
  'auto-2b2525',
  'auto-092846',
  'auto-3855fa',
  'auto-rgb-182-63-63',
  'auto-ddffda',
  'auto-5080c0',
  'auto-552f09',
  'auto-ffd700',
  'auto-e923236c',
  'auto-c75252d2',
  'auto-700f0fd2',
  'auto-0e406ecf',
  'auto-eedb89',
  'auto-a25d20',
  'auto-0b75fd6b',
  'auto-37bf37',
  'auto-ff6b6b',
  'auto-ff39397d',
  'auto-5499aa2c',
  'auto-1e62a74f',
  'auto-rgba-0-0-255-0-2',
  'auto-rgba-114-26-11-0-815',
  'auto-rgba-9-82-9-0-205',
  'auto-0f0d01',
  'auto-0000ff8a',
  'auto-222',
  'auto-c624',
  'auto-rgba-0-0-255-0-356',
  'auto-000',
  'auto-2d3447',
  'auto-f4f4f8',
  'auto-rgba-0-0-0-0-25',
  'auto-a2e5ff',
  'auto-ffcc70',
  'auto-d1d5db',
  'auto-rgb-110-67-11',
  'auto-rgb-25-56-82',
  'auto-8a2828',
  'auto-247d37',
  'auto-083b9dd9',
  'auto-rgb-109-129-145',
  'auto-rgb-112-66-20-0-8',
  'auto-rgb-179-212-255',
  'auto-rgb-255-255-255',
  'auto-ffb300',
  'auto-00a1d6',
  'auto-rgba-2-32-2-0-596',
  'auto-070d1c',
  'auto-ffff80',
  'auto-rgba-2-2-66-0-692',
  'auto-rgb-0-0-0',
  'auto-ace60c',
  'auto-rgba-70-63-5-0-767',
  'auto-19192880',
  'auto-70d2f9d4',
  'auto-rgba-0-0-255-0-02',
  'auto-rgba-0-0-255-0-26',
  'auto-rgba-85-107-47-0-404',
  'auto-2c2c2c',
  'auto-c8f8fe',
  'auto-380c2a',
  'auto-26a060',
];

/** Kept themes only — NightSky is the stable visual reference. */
export const THEME_IDS = ['nightsky', 'nightgen', 'helpgold', 'ocean', 'moss', 'slate'];
export const THEME_LABELS = {
  nightsky: 'NightSky',
  nightgen: 'NightGen',
  helpgold: 'HelpGold',
  ocean: 'Ocean',
  moss: 'Moss',
  slate: 'Slate',
};
/** Signature swatches for the color wheel (accent-forward, not canvas-dark). */
export const THEME_SWATCHES = {
  nightsky: '#295dbd',
  nightgen: '#3db8ff',
  helpgold: '#e2b36a',
  ocean: '#1c71c7',
  moss: '#66bb6a',
  slate: '#90a4ae',
};
const STORAGE_KEY = 'kiponos-theme';
const DEFAULT_THEME = 'nightsky';

export function applyTheme(themeId) {
  const theme = THEME_IDS.includes(themeId) ? themeId : DEFAULT_THEME;
  const root = window.document.body;
  root.style.backgroundColor = `var(--${theme}-canvas-background-color)`;
  THEME_TOKEN_SUFFIXES.forEach((suffix) => {
    root.style.setProperty(`--${suffix}`, `var(--${theme}-${suffix})`);
  });
  root.setAttribute('data-theme', theme);
  try {
    window.document.documentElement.setAttribute('data-theme', theme);
  } catch (_) {
    /* ignore */
  }
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch (_) {
    /* ignore */
  }
  return theme;
}

function loadStoredTheme() {
  try {
    const t = localStorage.getItem(STORAGE_KEY);
    if (THEME_IDS.includes(t)) return t;
  } catch (_) {
    /* ignore */
  }
  return DEFAULT_THEME;
}

export default function Themes() {
  const [theme, setTheme] = useState(loadStoredTheme);
  const n = THEME_IDS.length;

  const pickTheme = useCallback((id) => {
    if (THEME_IDS.includes(id)) {
      setTheme(id);
    }
  }, []);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  return (
    <div
      className='themeWheel'
      role='group'
      aria-label='Color theme'
      style={{ '--wheel-n': n }}
    >
      <div
        className='themeWheelHub'
        style={{ background: THEME_SWATCHES[theme] || THEME_SWATCHES[DEFAULT_THEME] }}
        title={THEME_LABELS[theme]}
        aria-hidden='true'
      />
      {THEME_IDS.map((id, i) => {
        const angleDeg = (i * 360) / n - 90;
        const active = theme === id;
        return (
          <button
            key={id}
            type='button'
            className={active ? 'themeSwatch themeActive' : 'themeSwatch'}
            style={{
              '--swatch': THEME_SWATCHES[id],
              '--angle': `${angleDeg}deg`,
            }}
            title={THEME_LABELS[id]}
            aria-label={THEME_LABELS[id]}
            aria-pressed={active}
            onClick={() => pickTheme(id)}
          />
        );
      })}
    </div>
  );
}
